export let languages = [
  {
    "lang": "Afrikaans",
    "tag": "af"
  },
  {
    "lang": "Albanian",
    "tag": "sq"
  },
  {
    "lang": "Amharic",
    "tag": "am"
  },
  {
    "lang": "Arabic",
    "tag": "ar"
  },
  {
    "lang": "Armenian",
    "tag": "hy"
  },
  {
    "lang": "Assamese",
    "tag": "as"
  },
  {
    "lang": "Azerbaijani",
    "tag": "az"
  },
  {
    "lang": "Bashkir",
    "tag": "ba"
  },
  {
    "lang": "Basque",
    "tag": "eu"
  },
  {
    "lang": "Belarusian",
    "tag": "be"
  },
  {
    "lang": "Bengali",
    "tag": "bn"
  },
  {
    "lang": "Bosnian",
    "tag": "bs"
  },
  {
    "lang": "Breton",
    "tag": "br"
  },
  {
    "lang": "Bulgarian",
    "tag": "bg"
  },
  {
    "lang": "Burmese",
    "tag": "my"
  },
  {
    "lang": "Catalan",
    "tag": "ca"
  },
  {
    "lang": "Chinese",
    "tag": "zh"
  },
  {
    "lang": "Corsican",
    "tag": "co"
  },
  {
    "lang": "Croatian",
    "tag": "hr"
  },
  {
    "lang": "Czech",
    "tag": "cs"
  },
  {
    "lang": "Danish",
    "tag": "da"
  },
  {
    "lang": "Dari",
    "tag": "prs"
  },
  {
    "lang": "Divehi",
    "tag": "dv"
  },
  {
    "lang": "Dutch",
    "tag": "nl"
  },
  {
    "lang": "English",
    "tag": "en"
  },
  {
    "lang": "Estonian",
    "tag": "et"
  },
  {
    "lang": "Faroese",
    "tag": "fo"
  },
  {
    "lang": "Filipino",
    "tag": "fil"
  },
  {
    "lang": "Finnish",
    "tag": "fi"
  },
  {
    "lang": "French",
    "tag": "fr"
  },
  {
    "lang": "Frisian",
    "tag": "fy"
  },
  {
    "lang": "Galician",
    "tag": "gl"
  },
  {
    "lang": "Georgian",
    "tag": "ka"
  },
  {
    "lang": "German",
    "tag": "de"
  },
  {
    "lang": "Greek",
    "tag": "el"
  },
  {
    "lang": "Greenlandic",
    "tag": "kl"
  },
  {
    "lang": "Gujarati",
    "tag": "gu"
  },
  {
    "lang": "Hausa",
    "tag": "ha"
  },
  {
    "lang": "Hebrew",
    "tag": "he"
  },
  {
    "lang": "Hindi",
    "tag": "hi"
  },
  {
    "lang": "Hungarian",
    "tag": "hu"
  },
  {
    "lang": "Icelandic",
    "tag": "is"
  },
  {
    "lang": "Igbo",
    "tag": "ig"
  },
  {
    "lang": "Indonesian",
    "tag": "id"
  },
  {
    "lang": "Inuktitut",
    "tag": "iu"
  },
  {
    "lang": "Irish",
    "tag": "ga"
  },
  {
    "lang": "Italian",
    "tag": "it"
  },
  {
    "lang": "Japanese",
    "tag": "ja"
  },
  {
    "lang": "K'iche",
    "tag": "quc"
  },
  {
    "lang": "Kannada",
    "tag": "kn"
  },
  {
    "lang": "Kazakh",
    "tag": "kk"
  },
  {
    "lang": "Khmer",
    "tag": "km"
  },
  {
    "lang": "Kinyarwanda",
    "tag": "rw"
  },
  {
    "lang": "Kiswahili",
    "tag": "sw"
  },
  {
    "lang": "Konkani",
    "tag": "kok"
  },
  {
    "lang": "Korean",
    "tag": "ko"
  },
  {
    "lang": "Kurdi",
    "tag": "ckb"
  },
  {
    "lang": "Kyrgyz",
    "tag": "ky"
  },
  {
    "lang": "Lao",
    "tag": "lo"
  },
  {
    "lang": "Latvian",
    "tag": "lv"
  },
  {
    "lang": "Lithuanian",
    "tag": "lt"
  },
  {
    "lang": "Lower Sorbian",
    "tag": "dsb"
  },
  {
    "lang": "Luxembourgish",
    "tag": "lb"
  },
  {
    "lang": "Macedonian",
    "tag": "mk"
  },
  {
    "lang": "Malay",
    "tag": "ms"
  },
  {
    "lang": "Malayalam",
    "tag": "ml"
  },
  {
    "lang": "Maltese",
    "tag": "mt"
  },
  {
    "lang": "Maori",
    "tag": "mi"
  },
  {
    "lang": "Mapudungun",
    "tag": "arn"
  },
  {
    "lang": "Marathi",
    "tag": "mr"
  },
  {
    "lang": "Mohawk",
    "tag": "moh"
  },
  {
    "lang": "Mongolian",
    "tag": "mn"
  },
  {
    "lang": "Nepali",
    "tag": "ne"
  },
  {
    "lang": "Norwegian",
    "tag": "no"
  },
  {
    "lang": "Norwegian (Bokmål)",
    "tag": "nb"
  },
  {
    "lang": "Norwegian (Nynorsk)",
    "tag": "nn"
  },
  {
    "lang": "Occitan",
    "tag": "oc"
  },
  {
    "lang": "Odia",
    "tag": "or"
  },
  {
    "lang": "Pashto",
    "tag": "ps"
  },
  {
    "lang": "Persian",
    "tag": "fa"
  },
  {
    "lang": "Polish",
    "tag": "pl"
  },
  {
    "lang": "Portuguese",
    "tag": "pt"
  },
  {
    "lang": "Punjabi",
    "tag": "pa"
  },
  {
    "lang": "Quechua",
    "tag": "qu"
  },
  {
    "lang": "Romanian",
    "tag": "ro"
  },
  {
    "lang": "Romansh",
    "tag": "rm"
  },
  {
    "lang": "Russian",
    "tag": "ru"
  },
  {
    "lang": "Sami (Inari)",
    "tag": "smn"
  },
  {
    "lang": "Sami (Lule)",
    "tag": "smj"
  },
  {
    "lang": "Sami (Northern)",
    "tag": "se"
  },
  {
    "lang": "Sami (Skolt)",
    "tag": "sms"
  },
  {
    "lang": "Sami (Southern)",
    "tag": "sma"
  },
  {
    "lang": "Sanskrit",
    "tag": "sa"
  },
  {
    "lang": "Scottish Gaelic",
    "tag": "gd"
  },
  {
    "lang": "Serbian",
    "tag": "sr"
  },
  {
    "lang": "Sesotho",
    "tag": "st"
  },
  {
    "lang": "Sinhala",
    "tag": "si"
  },
  {
    "lang": "Slovak",
    "tag": "sk"
  },
  {
    "lang": "Slovenian",
    "tag": "sl"
  },
  {
    "lang": "Spanish",
    "tag": "es"
  },
  {
    "lang": "Swedish",
    "tag": "sv"
  },
  {
    "lang": "Swiss German",
    "tag": "gsw"
  },
  {
    "lang": "Syriac",
    "tag": "syc"
  },
  {
    "lang": "Tajik",
    "tag": "tg"
  },
  {
    "lang": "Tamazight",
    "tag": "tzm"
  },
  {
    "lang": "Tamil",
    "tag": "ta"
  },
  {
    "lang": "Tatar",
    "tag": "tt"
  },
  {
    "lang": "Telugu",
    "tag": "te"
  },
  {
    "lang": "Thai",
    "tag": "th"
  },
  {
    "lang": "Tibetan",
    "tag": "bo"
  },
  {
    "lang": "Tswana",
    "tag": "tn"
  },
  {
    "lang": "Turkish",
    "tag": "tr"
  },
  {
    "lang": "Turkmen",
    "tag": "tk"
  },
  {
    "lang": "Ukrainian",
    "tag": "uk"
  },
  {
    "lang": "Upper Sorbian",
    "tag": "hsb"
  },
  {
    "lang": "Urdu",
    "tag": "ur"
  },
  {
    "lang": "Uyghur",
    "tag": "ug"
  },
  {
    "lang": "Uzbek",
    "tag": "uz"
  },
  {
    "lang": "Vietnamese",
    "tag": "vi"
  },
  {
    "lang": "Welsh",
    "tag": "cy"
  },
  {
    "lang": "Wolof",
    "tag": "wo"
  },
  {
    "lang": "Xhosa",
    "tag": "xh"
  },
  {
    "lang": "Yakut",
    "tag": "sah"
  },
  {
    "lang": "Yi",
    "tag": "ii"
  },
  {
    "lang": "Yoruba",
    "tag": "yo"
  },
  {
    "lang": "Zulu",
    "tag": "zu"
  }
];
